import { API_URL } from "../constants/constants"

// Получаем количество рефералов
export const getReferralStats = async (walletAddress, sessionToken) => {
  try {
    const response = await fetch(`${API_URL}/user/referrals`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken ? `Bearer ${sessionToken}` : "",
      },
      body: JSON.stringify({
        hashAddress: walletAddress,
      }),
    })

    const data = await response.json();

    if (data.success) {
      return {
        success: true,
        referralCount: data.referralCount || 0,
        totalEarned: data.totalEarned || 0,
        availableToWithdraw: data.availableToWithdraw || 0,
        withdrawnTotal: data.withdrawnTotal || 0
      };
    } else {
      throw new Error(data.error || 'Failed to fetch referral stats');
    }
  } catch (error) {
    console.error('Error fetching referral stats:', error);
    return {
      success: false,
      error: error.message,
      referralCount: 0,
      totalEarned: 0,
      availableToWithdraw: 0,
      withdrawnTotal: 0
    };
  }
};
